import { FORM_BUILDER_FIELD_TYPE } from "@loanbossinc/component-library";

import { shouldShowHotelRooms, shouldShowUnits, shouldShowSquareFeet } from "./section-property-details-rows-logic";

export const rows = {
  title: {
    label: "Property Details",
    isTitle: true
  },
  assetTypeRef: {
    label: "Asset Type",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "assetTypeRef",
        name: "assetTypeId",
        variant: "filled",
        parentId: "assetType",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      },
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        style: { marginLeft: "16px" },
        key: "assetClass",
        name: "assetClassId",
        variant: "filled",
        parentId: "assetClass",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: value => {
          console.log("onChange", { value });
        }
      }
    ]
  },
  assetSubtype: {
    label: "Asset Subtype",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.STRING,
        name: "assetSubtype",
        variant: "filled",
        multiline: true
      }
    ]
  },
  zoningRef: {
    label: "Zoning",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "zoningId",
        name: "zoningId",
        variant: "filled",
        parentId: "zoning",
        displayWith: option => option.name,
        setValueWith: option => option.id,
        onChange: id => {
          console.log("onChange", { id });
        }
      }
    ]
  },
  units: {
    label: "Multi Family Units",
    isVisible: data => shouldShowUnits(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "units",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  squareFeet: {
    label: "Sq Feet",
    isVisible: data => shouldShowSquareFeet(data),
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "squareFeet",
        variant: "filled"
      }
    ]
  },
  hotelRooms: {
    label: "Rooms",
    isVisible: data => shouldShowHotelRooms(data),
    cells: [{
      type: FORM_BUILDER_FIELD_TYPE.NUMBER,
      name: "hotelRooms",
      variant: "filled"
    }]
  },
  landSize: {
    label: "Land Size (Acres)",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.NUMBER,
        name: "landSize",
        variant: "filled",
        decimals: 2
      }
    ]
  },
  propertyStatus: {
    label: "Property Status",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "propertyStatusId",
        name: "propertyStatusId",
        variant: "filled",
        parentId: "propertyStatus",
        displayWith: option => option.name,
        setValueWith: option => option.id
      }
    ]
  },
  propertyUse: {
    label: "Property Use",
    cells: [
      {
        type: FORM_BUILDER_FIELD_TYPE.TYPEAHEAD,
        key: "propertyUseId",
        name: "propertyUseId",
        variant: "filled",
        parentId: "propertyUse",
        displayWith: option => option.name,
        setValueWith: option => option.id
      }
    ]
  }
};
